export default "__VITE_ASSET__kei9qdNr__"